import Notifier from 'common/helpers/Notifier';
import { useInvalidateQueries, useUpdateRecord } from './APIHooks';

export const useUpdateProcedure = (mutationConfig = {}) => {
  const invalidateQueries = useInvalidateQueries();

  return useUpdateRecord('procedure', {
    mutationConfig: {
      onError: () => {
        Notifier.dispatch('error', 'Failed to update procedure...');
      },
      onSettled: () => {
        invalidateQueries('interaction');
        invalidateQueries('procedure');
      },
      ...mutationConfig,
    },
  });
};
